/*
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav P�ibyl (pribyl@cadwork.cz)
 *
 */

import RenderDocument from "App/render_document";
import DirectionalLight from "App/view/lights/directional_light";
import {vec4} from "gl-matrix";

/**
 * @param aRenderDocument
 * @extends DirectionalLight
 * @constructor
 */
export default
class HeadLight extends DirectionalLight {

    public static TypeName: string = "HeadLight";

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this.setPosition(vec4.fromValues(0.0, 0.0, 0.1, 0.0));

        this._typeName = HeadLight.TypeName;
    }
}
